<template>
    <div>
        <!-- <input type="file" accept=".xlsx" @change="handleFileChange" /> -->
        <section id="month-schedule-table" class="emp-tbl-data-sec">
            <table v-if="newFormattedSchedulerData.length" id="ns-ms-table-sch" class="monthly-sch-tbl w-full">
                <tr v-for="(emp, empIndex) in newFormattedSchedulerData" :key="'emp'+emp.id+empIndex">
                    <!-- Left side employee details section -->
                    <td class="month-td-left">
                        <el-popover
                            placement="top-start"
                            :title="emp.full_name"
                            trigger="hover"
                            :content="emp.designation_info.name">
                                <div slot="reference" class="month-td-data-left px-2 py-1 left-tbl-col border border-gray-900">
                                <div class="text-ellipsis-style text-xs font-bold">{{ emp.full_name }}</div>
                                <div class="text-green font-normal" style="font-size: 10px;">{{ emp.designation_info.name }}</div>
                        </div>
                            </el-popover>
                    </td>
                    <!-- Right side shift data section -->
                    <td v-for="(shift, shift_index) in emp.all_sec_shift_data" :key="shift.uId"
                        :style="{ 'width': ((100 - 14) / emp.all_sec_shift_data.length) + '%' }"
                        class="text-center month-td-right" style="padding-left: 4px;"> 
                        <div v-if="emp.all_sec_shift_data.length" :ref="emp.id+ '-' +shift_index" class="month-td-data-right-shift border border-gray-900"
                            :class="[shift.leave_assigned ? 'empOnLeave' : '' , isCopyPaste ? 'cursor-pointer' : '']" >
                            <!-- For copy paste -->
                            <div>
                                <input :id="'cell-' +shift.uId" :ref="shift.uId" :key="shift.uId" v-model="shift.shift_name" type="text"  tabindex="0" style="width: 100%; height: 35px; background-color: #f9f9f9;" disabled class="ns-ms-input cursor-not-allowed">
                           </div>
                        </div>
                    </td>
                </tr>
            </table>
             <!-- If data is NA -->
             <el-empty v-else description="Something went wrong...">
                <BaseButton @click="$emit('getSecondaryStoreScheduleDataAll')" style="width: 110px;  margin-right:15px;" size="medium"
                    type="submit" buttonclass="btn p-2 text-xs ">
                    Retry
                </BaseButton>
            </el-empty>
        </section>
    </div>
</template>

<script>
    export default {
        name: "MonthlySchedulePlannerTableLI",
        props: {
                formattedSchedulerData: {
                    type: Array,
                    default: () => []
                }, 
                searchByEmployee: {
                    type: String,
                    default: () => ''
                }
            },
        computed: {
            searchByEmp(){
                return this.searchByEmployee;
            },
            newFormattedSchedulerData() {
                let result = JSON.parse(JSON.stringify(this.formattedSchedulerData));
                if (this.searchByEmployee) {
                    result = result.filter((item) => {
                        return this.searchByEmployee.toLowerCase().split(' ').every(v => item.full_name.toLowerCase().includes(v))
                    });
                } else {
                    result = result;
                }
                return result;
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>